import { counted } from '../plural';
import type { Messages } from '../shape';

export const auth = {
  fields: {
    email: 'Почта',
    workEmail: 'Рабочая почта',
    name: 'Имя',
    passphrase: 'Парольная фраза',
    newPassphrase: 'Новая парольная фраза',
    inviteCode: 'Код приглашения',
    recoveryCode: 'Код восстановления',
  },

  zeroKnowledge: 'Нулевое разглашение',

  signIn: {
    title: 'Разблокируйте хранилища',
    lede: 'Парольная фраза расшифровывает всё на этом устройстве. Сервер её не получает.',
    lost: 'Забыли?',
    busy: 'Выводим ключи…',
    submit: 'Разблокировать',
    signOut: 'Выйти',
    createOne: 'Создать',
  },

  signUp: {
    step: (n: number, total: number) => `Шаг ${n} из ${total}`,
    identifyTitle: 'Создайте аккаунт',
    identifyLede:
      'На этом сервере, который держит ваша команда. Экспорт в обычный Markdown — в любой момент.',
    continue: 'Продолжить',
    passphraseTitle: 'Придумайте парольную фразу',
    passphraseLede:
      'Этот ключ не покидает устройство. Им завёрнут каждый ключ хранилища, который у вас есть.',
    warning:
      'Если вы потеряете эту парольную фразу, заметки не восстановит никто — ни администратор, ни сервер. Сохраните комплект восстановления.',
    busy: 'Создаём ключи…',
    submit: 'Создать аккаунт',
    signInLink: 'Войти',
  },

  recover: {
    identifyTitle: 'Введите код восстановления',
    identifyLede:
      'Код из комплекта разворачивает мастер-ключ на этом устройстве. Сервер проверяет отдельный верификатор и самого кода не видит.',
    continue: 'Продолжить',
    resetTitle: 'Выберите новую парольную фразу',
    resetLede: 'Заметки остаются как есть — меняется только ключ, которым завёрнут мастер-ключ.',
    notice:
      'Все текущие сессии завершаются, а код восстановления, которым вы только что воспользовались, перестаёт работать. Новый комплект выдаётся на следующем экране.',
    busy: 'Заворачиваем ключи заново…',
    submit: 'Сменить парольную фразу',
    signInLink: 'Войти',
  },

  join: {
    title: 'Присоединиться по коду',
    lede: 'Тот, кто вас пригласил, передал вам код. До сервера он не доходит — именно им разворачивается ключ хранилища на этом устройстве.',
    busy: 'Проверяем…',
    submit: 'Продолжить',
    someone: 'Кто-то',
    role: 'Ваша роль',
    keys: 'Ключей в приглашении',
    notice:
      'Когда вы примете приглашение, ключ хранилища развернётся этим кодом и запечатается на ваш собственный ключ на этом устройстве. Тот, кто вас пригласил, прочитать ваш ключ не может, а сервер хранит только завёрнутую копию.',
    lockedNotice:
      'Приглашение запечатывается заново на ключ, который есть только у вас, — значит, сначала нужен ключ. Код сохранится, пока вы за ним ходите.',
    unlock: 'Разблокировать',
    signIn: 'Войти',
    createAccount: 'Создать аккаунт',
    acceptBusy: 'Запечатываем ключи заново…',
    accept: 'Принять и разблокировать',
    decline: 'Отклонить',
    back: 'К своим хранилищам',
    wrongCode: 'Этот код здесь ничего не открывает.',
    locked: 'Ваши ключи на этом устройстве заблокированы. Разблокируйте их и снова откройте код.',
    readOnly:
      'Включён режим только для чтения. Выключите его в меню аккаунта, чтобы принять приглашение.',
  },

  kit: {
    step: 'Комплект восстановления',
    title: 'Сохраните комплект восстановления',
    lede: 'Код показывается один раз. Это единственный путь обратно к заметкам, если вы забудете парольную фразу.',
    notice:
      'Сервер держит ваш мастер-ключ, завёрнутый в ключ, который выведен из этого кода, и развернуть его не может. Ваш администратор — тоже.',
    download: 'Скачать комплект',
    downloadAgain: 'Скачать ещё раз',
    copy: 'Скопировать код',
    confirm: 'Код сохранён в надёжном месте, офлайн.',
    open: 'Открыть Shelf',
  },

  meter: {
    common: 'Содержит очень распространённое слово.',
    tooShort: (n: number) => `Минимум ${counted(n, ['символ', 'символа', 'символов'])}.`,
    fair: 'Длина надёжнее, чем спецсимволы.',
    good: 'Хорошо. Четвёртое слово сделает фразу надёжной.',
    strong: 'Надёжно.',
  },

  kitFile: {
    title: 'КОМПЛЕКТ ВОССТАНОВЛЕНИЯ SHELF',
    server: 'Сервер',
    account: 'Аккаунт',
    name: 'Имя',
    key: 'Ключ',
    issued: 'Выдан',
    code: 'КОД ВОССТАНОВЛЕНИЯ',
    body:
      'Этот код — единственный путь к вашим заметкам, если вы забудете парольную\n' +
      'фразу. Он нигде не хранится: сервер держит ваш мастер-ключ, завёрнутый в\n' +
      'ключ, который выведен из этого кода, и развернуть его не может — как и ваш\n' +
      'администратор.',
    offline: 'Держите код офлайн. Тот, у кого он есть, читает всё, что читаете вы.',
  },
} satisfies Messages['auth'];
